<template>
  <el-select v-model="val" filterable remote reserve-keyword :placeholder="$attrs['placeholder'] || '请输入内容'" :remote-method="remoteMethod" :loading="loading" @change="change" :clearable="$attrs['clearable']" @clear="clear">
    <el-option v-for="(item, index) in list" :key="index" :value="getValueKey(item)" :label="getLabel(item)"></el-option>
    <slot :data="list"/>
  </el-select>
</template>
<script>
  /*
  <mc-remote-select-opt
    v-model="form.placeOfProduction"
    listKey="result" // 接口返回的list路径,比如:result.list
    valueKey="udaValue" // 后端需要的值 (支持val1,val2,text1)
    labelKey="udaValue,udaValueDesc" // 需要展示的字段以,隔开
    method="post" // 请求类型
    query="udaVauleOrUdaName" // 后端用于查询的字段
    url="/commoditymanagement/uda/getUdaValuesByUda" // 接口地址
    :ajaxData="{__isRP: false, udaKey: 'placeOfProduction'}" // 额外的ajax数据
    clearable // 是否显示清空按钮
    >
  </mc-remote-select-opt>
  */

  export default {
    name: 'mc-remote-select-opt',
    props: ['searchStr'],
    model: {
      prop: 'searchStr',
      event: 'update'
    },
    data () {
      return {
        val: '',
        list: [],
        map: {},
        loading: false
      }
    },
    watch: {
      searchStr() {
        if (this.val !== this.searchStr) {
          this.remoteMethod(this.searchStr)
        }
        this.val = this.searchStr
      }
    },
    methods: {
      getLabel (obj) {
        let ar = this.$attrs['labelKey'].split(',')
        let ar2 = []
        ar.forEach(item => {
          if (obj[item]) {
            ar2.push(obj[item])
          } else {
            ar2.push(item)
          }
        })
        return ar2.join(' ')
      },
      remoteMethod (query) {
        this.list = []
        if (query && query !== '') {
          if (!this.$attrs.url) {
            return
          }
          let url = this.$attrs.url
          this.loading = true
          let params = Object.assign(this.$attrs.options || {}, this.$attrs.ajaxData, {[this.$attrs.query]: query})
          this.$ajax[this.$attrs['method'] || 'get'](url, params).then(rs => {
            let listKey = this.$attrs['listKey'] // list路径
            let list = []
            if (listKey && rs) {
              list = this.getList(rs, listKey)
            }
            if (rs && list && list.length !== 0) {
              this.loading = false
              this.list = [...list]
              // 生成map
              this.map = {}
              this.list.forEach(item => {
                this.$set(this.map, this.getValueKey(item), item)
              })
            }
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.list = []
        }
      },
      getValueKey (obj) {
        let valueKey = this.$attrs['valueKey']
        let ar = valueKey.split(',')
        let ar2 = []
        ar.forEach(item => {
          if (obj[item]) {
            ar2.push(obj[item])
          }
        })
        return ar2.join(',')
      },
      getList(rs, listKey) {
        let ar = listKey.split('.')
        let num = 0
        function a (obj, key) {
          if (obj[key]) {
            if (num < ar.length - 1) {
              num++
              a(obj[key], ar[num])
            } else {
              return obj[key] || []
            }
          } else {
            return []
          }
        }
        return a(rs, ar[num])
      },
      clear () {
        this.map = {}
        this.list = []
      },
      change (val) {
        this.$emit('update', val)
        this.$emit('change', this.map[val] || {})
      }
    },
    mounted () {
      this.val = this.searchStr
      this.remoteMethod(this.searchStr)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/mc-ui/remote-select-opt/index.vue